module.exports = __webpack_public_path__ + "static/media/checkFilled.8ac2b7c7.svg";